var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFolderIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 73,
    viewBox: "0 0 100 73",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 73,
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.26611 12.1624C9.26611 8.84868 11.9524 6.16238 15.2661 6.16238H28.1025C30.5337 6.16238 32.736 7.5968 33.7188 9.82048C34.7015 12.0442 36.9038 13.4786 39.335 13.4786H61.0027H93.8051C97.1188 13.4786 99.8051 16.1649 99.8051 19.4786V67C99.8051 70.3138 97.1188 73 93.8051 73H15.2661C11.9524 73 9.26611 70.3138 9.26611 67V12.1624Z",
    fill: "#9B9BBE",
    fillOpacity: 0.3
  })), /*#__PURE__*/React.createElement("path", {
    d: "M5 4.00006C5 1.79092 6.79086 6.10352e-05 9 6.10352e-05H27.6286C29.2063 6.10352e-05 30.6367 0.927475 31.2804 2.36788L32.7353 5.62297C33.3791 7.06337 34.8094 7.99078 36.3871 7.99078H62.1429H96C98.2091 7.99078 100 9.78165 100 11.9908V69.0001C100 71.2092 98.2091 73.0001 96 73.0001H11C7.68629 73.0001 5 70.3138 5 67.0001V4.00006Z",
    fill: "#3537E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93 18C93 15.2386 90.7614 13 88 13H4C2.34315 13 1 14.3432 1 16V69C1 70.6569 2.34315 72 4 72H93.9293C93.3256 70.9485 93 69.7484 93 68.5147V18Z",
    fill: "white",
    stroke: "#3537E5",
    strokeWidth: 2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f",
    x: -10.7339,
    y: -13.8376,
    width: 130.539,
    height: 106.838,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10,
    result: "effect1_foregroundBlur"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 73,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolderIcon);
export default __webpack_public_path__ + "static/media/folder-icon.bba7d9542fd0c918ea51f1f471ac37d3.svg";
export { ForwardRef as ReactComponent };